module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-table-display"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index
    }
  }), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].index,
      "data": _vm.index,
      "searchDisp": false,
      "tablePageDisp": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bad9d1c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoTableDisplay.vue
// module id = 3965
// module chunks = 1